export default function ($translate) {
    return {
        KEYS: {
            ONE_PAGE: 'ONE_PAGE',
            SEPARATE_PAGES: 'SEPARATE_PAGES'
        },
        LABELS: {
            ONE_PAGE: $translate.instant('formsDisplaySettings.Display all on one page'),
            SEPARATE_PAGES: $translate.instant('formsDisplaySettings.Split to pages')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/display/type/index.js